module.exports = __webpack_public_path__ + "media/images/icon-ab-70bb5438b7498a20f89497b1f5d22adc.svg";